import React, { useState } from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import { Body1, Body2, Sub2 } from "../../../../assets/styles/Typography";
import { Button } from "../../../../assets/styles/ButtonStyle";
import images from "../../../../assets/styles/Images";
import { BoxWrap } from "../../../../assets/styles/BusinessAnalysisStyle";
import { useAtom } from "jotai";
import { 
  IS_LOGGED_IN, 
  AUTODISPLAY_CONTENT_LIST, 
  } from "../../../AtomStates";
import PopupWrap from "../../../../assets/styles/Popup";
import OrganismDisplayViewApiPreview from "../../../Global/components/organisms/OrganismDisplayViewApiPreview";
import OrganismInfoDisplayViewCustomPreview from "../../../Global/components/organisms/OrganismInfoDisplayViewCustomPreview";
import MoleculeApiContentPopup from "../molecules/MoleculeApiContentPopup";
import MoleculeInfoContentSettingPopup from "../molecules/MoleculeInfoContentSettingPopup";
import {
   updateDeviceOnServer
} from "../../../../utils/indexedDB";
import MoleculeTitleCorrection from "../../../CreateEducationContentPage/components/molecules/MoleculeTitleCorrection";


const OrganismInfoDeviceList = ({ customerId, contentList: inputContentList = [], lotationDetail = null, onLotationUpdate = null }) => {
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
 
  // 미리보기 상태
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [showSensorPreview, setShowSensorPreview] = useState(false);
  const [selectedContentId, setSelectedContentId] = useState(null);

  // 삭제 팝업
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [contentToDelete, setContentToDelete] = useState(null);

    const [contentToEdit, setContentToEdit] = useState(null);
  const [showTitleEditPopup, setShowTitleEditPopup] = useState(false);

  const list = inputContentList.length > 0 ? inputContentList : contentList;
  const scheduledList = Array.isArray(list) && lotationDetail
    ? lotationDetail.lotationContents 
    : [];

   

  const handleCloseTemplatePreview = () => {
    setShowTemplatePreview(false);
    setSelectedContentId(null);
  };

  const handleCloseSensorPreview = () => {
    setShowSensorPreview(false);
    setSelectedContentId(null);
  };

 const handleDeleteContent = async (contentId) => {
      console.log("contentId", contentId);
      await updateDeviceOnServer(contentId, { deleteState: 1 });
     
  
      setContentList((prev) => prev.filter((c) => c._id !== contentId));
       setShowConfirmPopup(false);
    setContentToDelete(null);
    };

    // 제목 수정 관련 핸들러들
  const handleEditTitle = (content) => {
    setContentToEdit(content);
    setShowTitleEditPopup(true);
  };

  const handleTitleEditCancel = () => {
    setShowTitleEditPopup(false);
    setContentToEdit(null);
  };

  const handleTitleEditConfirm = async (newTitle) => {
      if (!contentToEdit || !newTitle.trim()) return;
   
      try {
        // 서버에 제목 업데이트
        await  updateDeviceOnServer (contentToEdit._id, {
          "contentData.title": newTitle.trim(),
        });

  
        // 로컬 상태 업데이트
        setContentList((prev) =>
          prev.map((content) =>
            content._id === contentToEdit._id
              ? {
                  ...content, // 기존 content 속성 복사
                  contentData: {
                    ...content.contentData, // 기존 contentData 속성 복사
                    title: newTitle.trim(),
                  }, // title 업데이트
                }
              : content
          )
        );
  
        setShowTitleEditPopup(false);
        setContentToEdit(null);
      } catch (error) {
        console.error("제목 수정 중 오류 발생:", error);
      }
    };

  const [showArrangePopup, setShowArrangePopup] = useState(false);
  const [showSettingPopup, setShowSettingPopup] = useState(false);
  const [showCopySuccessPopup, setShowCopySuccessPopup] = useState(false);
  const [copiedInfo, setCopiedInfo] = useState({ type: "", content: "" });

  const handleCopyToClipboard = async (content, type) => {
    try {
      await navigator.clipboard.writeText(content);
      setCopiedInfo({ type, content });
      setShowCopySuccessPopup(true);
    } catch (error) {
      console.error("복사 실패:", error);
      setCopiedInfo({ type: "오류", content: "복사에 실패했습니다." });
      setShowCopySuccessPopup(true);
    }
  };

  return (
    <Container>
      <Header>
        <HeaderLeft>
          {lotationDetail && (
            <DirectLinkContainer>
              {/* <StyledFrame>
                <div>
                  <StyledIdSpan01>다이렉트 링크 : </StyledIdSpan01>
                  <StyledIdSpan02
                    onClick={() => {
                      const vid = lotationDetail.viewId || lotationDetail._id;
                      const url = `http://${window.location.host}/AutodisplayViewLinkApiLotation/${vid}`;
                      window.open(url, "_blank");
                    }}
                    style={{ cursor: "pointer", textDecoration: "underline", color: "#007bff" }}
                  >
                    AutodisplayViewLinkApiLotation
                  </StyledIdSpan02>
                </div>
                <CopyButton
                  onClick={() => {
                    const vid = lotationDetail.viewId || lotationDetail._id;
                    const url = `${window.location.host}/AutodisplayViewLinkApiLotation/${vid}`;
                    handleCopyToClipboard(url, "다이렉트 링크");
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z" fill="#9CA3AF"/>
                  </svg>
                </CopyButton>
              </StyledFrame> */}
            </DirectLinkContainer>
          )}
        </HeaderLeft>
        <HeaderRight>
          <StyledContentButton onClick={() => setShowSettingPopup(true)}>
             <svg
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ flexShrink: 0 }}
                >
                  <circle
                    cx="10.11"
                    cy="10.11"
                    r="7.11"
                    stroke="#256EF4"
                    strokeWidth="1.5"
                  />
                  <line
                    x1="9.89549"
                    y1="6.4099"
                    x2="9.89549"
                    y2="10.1839"
                    stroke="#256EF4"
                    strokeWidth="1.86911"
                    strokeLinecap="round"
                  />
                  <line
                    x1="11.8236"
                    y1="11.5456"
                    x2="9.92994"
                    y2="10.1967"
                    stroke="#256EF4"
                    strokeWidth="1.86911"
                    strokeLinecap="round"
                  />
                </svg>
            <Sub2 color="primary">편성 시간 설정</Sub2>
          </StyledContentButton>
          {/* <StyledContentButton onClick={() => setShowArrangePopup(true)}>
            <svg
              width={20}
              height={20}
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ flexShrink: 0 }}
            >
              <circle
                cx="10.11"
                cy="10.11"
                r="7.11"
                stroke="#256EF4"
                strokeWidth="1.5"
              />
              <line
                x1="9.89549"
                y1="6.4099"
                x2="9.89549"
                y2="10.1839"
                stroke="#256EF4"
                strokeWidth="1.86911"
                strokeLinecap="round"
              />
              <line
                x1="11.8236"
                y1="11.5456"
                x2="9.92994"
                y2="10.1967"
                stroke="#256EF4"
                strokeWidth="1.86911"
                strokeLinecap="round"
              />
            </svg>
            <Sub2 color="primary">콘텐츠 편성하기</Sub2>
          </StyledContentButton> */}
        </HeaderRight>
      </Header>

      <ContentListWrap>
        {list.length === 0 ? (
          <BoxWrap NoData style={{ height: "300px" }}>
            <img src={images.ListFillPrimary} alt="" />
            <Body2 color="gray700" align="center !important">
             등록된 기기가 없습니다.
            </Body2>
          </BoxWrap>
        ) : (
          <Table>
            <colgroup>
              <col width="43%" />
              <col width="12%" />
              <col width="12%" />
              <col width="23%" />
         
            </colgroup>
            <TableHeader>
              <tr>
                <th>
                  <Body1 color="gray700" align="left">청정기 정보</Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">제작일</Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">수정일</Body1>
                </th>
                <th>
                  <Body1 color="gray700" align="left">다이렉트 링크</Body1>
                </th>
            
              </tr>
            </TableHeader>
            <TableBody>
              {list.map((content) => (
                <tr key={content._id}>
                  <td>
                    <ContentNameCell>
                      <Body2 color="gray400" style={{ fontWeight: 700 }}>
                        {content.contentData?.title || content.dataAnalysis?.title}
                      </Body2>
                      <Body2 color="gray700" style={{ marginTop: 2 }}>
                        {content?.contentData?.dataType === "sensor"
                          ? `SN ${content?.contentData?.serialCode || ""} - ${
                              content?.contentData?.sensorDataName || ""
                            }`
                          : content?.contentData?.dataType || "api"}
                      </Body2>
                    </ContentNameCell>
                  </td>
                  <td>
                    <Body2 color="gray700" align="left">
                      {(() => {
                        const dateStr = content.createDate;
                        if (!dateStr) return "-";
                        const match = dateStr.match(/^(.+?)\s+(오전|오후)\s+(.+)$/);
                        if (match) {
                          const datePart = match[1];
                          const amPm = match[2];
                          const timePart = match[3];
                          return (
                            <>
                              {datePart}
                              <br />
                              <Body2 color="gray700" align="left">
                                {amPm} {timePart}
                              </Body2>
                            </>
                          );
                        }
                        return dateStr;
                      })()}
                    </Body2>
                  </td>
                  <td>
                    <Body2 color="gray700" align="left">
                      <div style={{ textAlign: "left" }}>
                        {content.createDate === content.updateDate
                          ? "-"
                          : (() => {
                              const dateStr = content.updateDate;
                              if (!dateStr) return "-";
                              const match = dateStr.match(/^(.+?)\s+(오전|오후)\s+(.+)$/);
                              if (match) {
                                const datePart = match[1];
                                const amPm = match[2];
                                const timePart = match[3];
                                return (
                                  <div style={{ textAlign: "left" }}>
                                    {datePart}
                                    <br />
                                    <span>
                                      {amPm} {timePart}
                                    </span>
                                  </div>
                                );
                              }
                              return dateStr;
                            })()}
                      </div>
                    </Body2>
                  </td>
                  <td>
                    <ActionButtonsCell>
                    <div>
                      <StyledIdSpan02
                        onClick={() => {
                          const url = `http://${
                            window.location.host
                          }/AutodisplayViewLinkLotation/${
                            content.viewId || content._id
                          }`;
                          window.open(url, "_blank");
                        }}
                        style={{
                          cursor: "pointer",
                          textDecoration: "underline",
                          color: "#007bff",
                        }}
                      >
                        링크 바로가기
                      </StyledIdSpan02>
                    </div>                      
                    <CopyButton
                      onClick={() =>
                        handleCopyToClipboard(
                          `${window.location.host}/AutodisplayViewLinkLotation/${
                            content.viewId || content._id
                          }`,
                          "다이렉트 링크"
                        )
                      }
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                          fill="#9CA3AF"
                        />
                      </svg>
                    </CopyButton>
                       <ButtonGroup>
                     <EditButton
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleEditTitle(content);
                          }}
                        >
                          <svg
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_222_5931)">
                              <path
                                d="M2.55835 14.504C2.52098 14.5415 2.5 14.5922 2.5 14.6452V17.4875C2.5 17.598 2.58954 17.6875 2.7 17.6875H5.54197C5.59512 17.6875 5.64609 17.6663 5.68362 17.6287L13.7001 9.58587C13.778 9.50773 13.7779 9.38127 13.6999 9.30326L10.8578 6.4611C10.7796 6.38291 10.6528 6.38301 10.5747 6.46133L2.55835 14.504ZM17.2583 6.05417C17.5833 5.72917 17.5833 5.20417 17.2583 4.87917L15.3083 2.92917C14.9833 2.60417 14.4583 2.60417 14.1333 2.92917L12.7498 4.31275C12.6716 4.39086 12.6717 4.51749 12.7498 4.5956L15.5919 7.43775C15.67 7.51586 15.7966 7.51586 15.8748 7.43775L17.2583 6.05417Z"
                                stroke="#666666"
                                strokeWidth="1.67"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_222_5931">
                                <rect
                                  width="20"
                                  height="20"
                                  fill="white"
                                  transform="translate(0 0.1875)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </EditButton>
                      <DeleteButton
                        type="button"
                        onClick={() => {
                          setContentToDelete(content._id);
                          setShowConfirmPopup(true);
                        }}
                      >
                        <svg
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_992_2924)">
                            <path
                              d="M16.8364 3.70215C17.2366 3.70215 17.5618 4.02663 17.562 4.42676C17.562 4.82711 17.2368 5.15234 16.8364 5.15234H16.4419V15.3652C16.4419 17.367 14.8196 18.9902 12.8179 18.9902H6.71533C4.71361 18.9902 3.09131 17.367 3.09131 15.3652V5.15234H2.69678C2.29664 5.1521 1.97217 4.82695 1.97217 4.42676C1.97243 4.02678 2.2968 3.70239 2.69678 3.70215H16.8364ZM4.54053 5.15234V15.3652C4.54053 16.5663 5.5143 17.54 6.71533 17.54H12.8179C14.0189 17.54 14.9927 16.5663 14.9927 15.3652V5.15234H4.54053ZM8.24854 7.12402C8.64858 7.12419 8.97289 7.44861 8.97314 7.84863V14.5791C8.97314 14.9793 8.64874 15.3045 8.24854 15.3047C7.84819 15.3047 7.52295 14.9794 7.52295 14.5791V7.84863C7.52321 7.44851 7.84835 7.12402 8.24854 7.12402ZM11.2837 7.12402C11.6839 7.12402 12.009 7.44851 12.0093 7.84863V14.5791C12.0093 14.9794 11.684 15.3047 11.2837 15.3047C10.8835 15.3045 10.5591 14.9794 10.5591 14.5791V7.84863C10.5593 7.4486 10.8836 7.12417 11.2837 7.12402ZM12.064 0.988281C12.4641 0.988474 12.7884 1.31279 12.7886 1.71289C12.7886 2.11312 12.4641 2.43828 12.064 2.43848H7.47119C7.07096 2.43834 6.74658 2.11315 6.74658 1.71289C6.74674 1.31276 7.07106 0.988422 7.47119 0.988281H12.064Z"
                              fill="#666666"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_992_2924">
                              <rect width="20" height="20" fill="white" transform="translate(0 0.1875)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </DeleteButton>
                      </ButtonGroup>
                    </ActionButtonsCell>
                  </td>
                </tr>
              ))}
            </TableBody>
          </Table>
        )}
      </ContentListWrap>

      {/* 삭제 확인 팝업 */}
      {showConfirmPopup && contentToDelete && (
        <PopupWrap
          Warning
          title="정말 삭제 하시겠습니까?"
          message={<>해당 콘텐츠가 삭제됩니다.</>}
          buttonType="Outline"
          closeText="취소"
          confirmText="삭제"
          isModal={false}
          onCancel={() => {
            setShowConfirmPopup(false);
            setContentToDelete(null);
          }}
          onConfirm={() => handleDeleteContent(contentToDelete)}
        />
      )}

      {/* 미리보기 */}
      {showTemplatePreview && (
        <OrganismDisplayViewApiPreview onClose={handleCloseTemplatePreview} />
      )}
      {showSensorPreview && (
        <OrganismInfoDisplayViewCustomPreview onClose={handleCloseSensorPreview} />
      )}

      {showArrangePopup && (
        <MoleculeApiContentPopup
          onClose={() => setShowArrangePopup(false)}
          contentList={list}
          lotationDetail={lotationDetail}
          onLotationUpdate={onLotationUpdate}
        />
      )}

      {showSettingPopup && (
        <MoleculeInfoContentSettingPopup
          customerId={customerId}
          onClose={() => setShowSettingPopup(false)}
          onUpdate={onLotationUpdate}
          contentList={list}
        />
      )}

      {showCopySuccessPopup && (
        <PopupWrap
          Check
          title="클립보드에 복사가 완료되었습니다."
          message={
            copiedInfo.type === "오류"
              ? copiedInfo.content
              : `${copiedInfo.type}가 클립보드에 복사되었습니다.`
          }
          buttonType="Outline"
          confirmText="확인"
          isModal={false}
          onConfirm={() => {
            setShowCopySuccessPopup(false);
            setCopiedInfo({ type: "", content: "" });
          }}
        />
      )}

      {showTitleEditPopup && contentToEdit && (
              <TitleEditPopupOverlay>
                <MoleculeTitleCorrection
                  initialTitle={contentToEdit?.contentData?.title || ""}
                  onCancel={handleTitleEditCancel}
                  onConfirm={handleTitleEditConfirm}
                  headerTitle ="기기명 수정"
                />
              </TitleEditPopupOverlay>
            )}
    </Container>
  );
};

export default OrganismInfoDeviceList;

const Container = styled.div`
  width: 1240px;
  background: white;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px 20px 0px;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;


const ContentListWrap = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  background: ${palette.white};
  // OrganismApiDashboardContentList 테이블과 동일하게 hover/보더 간격 느낌 맞춤
`;

const TableHeader = styled.thead`
  background: #eef2f7;

  th {
    padding: 16px 20px;
    border-bottom: 1px solid ${palette.outlineGray};
  }
`;

const TableBody = styled.tbody`
  tr {
    &:hover {
      background: #f9fafb;
    }
    border-bottom: 1px solid ${palette.outlineGray};
  }

  td {
    padding: 16px 20px;
  }
`;

const ContentNameCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

const ActionButtonsCell = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
`;

const PreviewButton = styled.button`
  background: ${palette.gray100};
  color: ${palette.gray700};
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover {
    background: ${palette.gray200};
  }
`;

const DeleteButton = styled.button`
  color: #666666;
  border: none;
  padding: 4px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;

  &:hover {
    svg {
      path {
        fill: rgb(73, 73, 73);
      }
    }
  }
`;

const NoDataBox = styled.div`
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${palette.white};
  border: 1px dashed ${palette.outlineGray};
  border-radius: 8px;
`;

const StyledContentButton = styled(Button).attrs({
  Large: true,
  PrimaryLightest: true,
  Fill: true,
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #e6f0ff !important;
  }
`;


// 다이렉트 링크 관련 스타일
const DirectLinkContainer = styled.div`
  margin-left: 0px;
`;

const StyledFrame = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
`;

const StyledIdSpan01 = styled.span`
  color: var(--color-text-subtle, #464c53);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const StyledIdSpan02 = styled.span`
  color: var(--color-text-primary, #0b50d0);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${palette.gray100};
  }
`;


const EditButton = styled.button`
  color: #666666;
  border: none;
  padding: 4px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;

  &:hover {
    svg {
      path {
        fill: rgb(73, 73, 73);
      }
    }
  }
`;
const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-left: 30px;
`;

// 제목 수정 팝업 오버레이
const TitleEditPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;
